import AbstractView = require("./abstract/AbstractView");

class AuraView extends AbstractView {


    constructor(id: number = -1, selector: JQuery) {
        super(id, selector);
    }

    init(): void {
    }

}

export = AuraView;